import PublicNav from '../components/PublicNav';
import './AppsPage.css';

const LIVE_FEATURES = [
  { icon: '📺', text: 'Live-Matten-Übersicht — alle Kämpfe auf einen Blick, aktualisiert alle 20 Sekunden' },
  { icon: '📋', text: 'Vollständige Startliste mit Filterung nach Status, Matte und Kategorie' },
  { icon: '🔍', text: 'Athletensuche — Namen eingeben und alle Kämpfe dieses Athleten finden' },
  { icon: '🌐', text: 'Kein Login nötig — öffentlich zugänglich für Zuschauer, Eltern, alle Interessierten' },
  { icon: '📱', text: 'Optimiert für Smartphone & Tablet — als App auf dem Homescreen speicherbar' },
];

const MY_FEATURES = [
  { icon: '👨‍🏫', text: 'Trainer-Login mit Vereinszugangsdaten — eigenes Team auf einen Blick' },
  { icon: '🔑', text: 'PINs für Athleten generieren — 6-stellige Codes per QR oder mündlich weitergeben' },
  { icon: '🥋', text: 'Athleten sehen nur ihre eigenen Kämpfe — nächster Kampf farblich hervorgehoben' },
  { icon: '📲', text: 'QR-Code scannen → Athlet sofort eingeloggt, ohne PIN-Eingabe' },
  { icon: '⚡', text: 'Live-Updates alle 20 Sekunden — sofort informiert wenn der nächste Kampf ansteht' },
];

const FAQS = [
  {
    q: 'Brauche ich ein Konto?',
    a: 'TDA Live ist komplett ohne Login nutzbar. Trainer nutzen dieselben Zugangsdaten wie auf events.tda-intl.org. Athleten erhalten einen 6-stelligen PIN von ihrem Trainer.',
  },
  {
    q: 'Kostet die App etwas?',
    a: 'Nein — beide Apps sind kostenlos und für alle TDA-Mitglieder und Turnierteilnehmer zugänglich.',
  },
  {
    q: 'Muss ich die App aktualisieren?',
    a: 'Nein. Die App aktualisiert sich beim nächsten Öffnen automatisch. Kein manuelles Update nötig.',
  },
  {
    q: 'Ich habe keine Zugangsdaten als Trainer?',
    a: 'Nutze dieselben Login-Daten wie auf events.tda-intl.org. Noch kein Konto? Über „Registrieren" auf dieser Seite anmelden.',
  },
];

export default function AppsPage() {
  return (
    <div className="ap-page">
      <PublicNav />

      {/* HERO */}
      <div className="ap-hero">
        <span className="ap-eyebrow">TDA Digital</span>
        <h1 className="ap-hero-title">TDA Apps</h1>
        <p className="ap-hero-sub">
          Zwei kostenlose Apps für Wettkämpfe — live verfolgen, Team verwalten,
          eigene Kämpfe sehen. Direkt im Browser, kein Download nötig.
        </p>
        <div className="ap-badge">
          <span>✅</span>
          <span>Kostenlos · <strong>Kein App Store</strong> · Direkt auf den Homescreen</span>
        </div>
      </div>

      {/* APP CARDS */}
      <div className="ap-container">
        <div className="ap-cards">

          <div className="ap-card">
            <div className="ap-card-top">
              <img src="/icon-tda-live.png" alt="TDA Live" className="ap-card-icon"
                onError={e => { e.target.style.display = 'none'; }} />
              <div>
                <div className="ap-card-name">TDA Live</div>
                <a href="https://live.tda-intl.org" target="_blank" rel="noopener noreferrer" className="ap-card-url">
                  live.tda-intl.org
                </a>
                <div className="ap-card-tagline">
                  Echtzeit-Turnieransicht für Zuschauer und Eltern — ohne Login.
                </div>
              </div>
            </div>
            <div className="ap-card-body">
              <div className="ap-for-tag">👁 Für alle — kein Login</div>
              <ul className="ap-features">
                {LIVE_FEATURES.map((f, i) => (
                  <li key={i}><span>{f.icon}</span><span>{f.text}</span></li>
                ))}
              </ul>
              <a href="https://live.tda-intl.org" target="_blank" rel="noopener noreferrer" className="ap-open-btn">
                ▶ TDA Live öffnen
              </a>
            </div>
          </div>

          <div className="ap-card">
            <div className="ap-card-top">
              <img src="/icon-mein-tda.png" alt="Mein TDA" className="ap-card-icon"
                onError={e => { e.target.style.display = 'none'; }} />
              <div>
                <div className="ap-card-name">Mein TDA</div>
                <a href="https://my.tda-intl.org" target="_blank" rel="noopener noreferrer" className="ap-card-url">
                  my.tda-intl.org
                </a>
                <div className="ap-card-tagline">
                  Persönliches Portal für Trainer und Athleten — Login, Kämpfe, PINs.
                </div>
              </div>
            </div>
            <div className="ap-card-body">
              <div className="ap-for-tag">🔐 Trainer-Login / Athleten-PIN</div>
              <ul className="ap-features">
                {MY_FEATURES.map((f, i) => (
                  <li key={i}><span>{f.icon}</span><span>{f.text}</span></li>
                ))}
              </ul>
              <a href="https://my.tda-intl.org" target="_blank" rel="noopener noreferrer" className="ap-open-btn">
                ▶ Mein TDA öffnen
              </a>
            </div>
          </div>

        </div>

        {/* WORKFLOW */}
        <div className="ap-section">
          <div className="ap-section-title">So funktioniert es</div>
          <div className="ap-section-sub">Schritt für Schritt — für Trainer und Athleten</div>

          <div className="ap-workflow-grid">

            <div className="ap-wf-card">
              <div className="ap-wf-role">Für Trainer</div>
              <div className="ap-wf-title">Team & PIN-Verwaltung</div>
              <ul className="ap-wf-steps">
                <li className="ap-wf-step"><span>1️⃣</span><span><strong>my.tda-intl.org</strong> öffnen → „Ich bin Trainer" wählen</span></li>
                <li className="ap-wf-step"><span>2️⃣</span><span>Mit Vereins-E-Mail und Passwort anmelden (gleiche Zugangsdaten wie auf dieser Seite)</span></li>
                <li className="ap-wf-step"><span>3️⃣</span><span>Turnier auswählen — heutiges öffnet automatisch</span></li>
                <li className="ap-wf-step"><span>4️⃣</span><span>Team sehen: alle Athleten mit Kämpfen, Matten und Status</span></li>
                <li className="ap-wf-step"><span>5️⃣</span><span>„PINs erstellen" antippen → <strong>6-stelliger PIN</strong> für jeden Athleten wird generiert</span></li>
                <li className="ap-wf-step"><span>6️⃣</span><span>PIN mündlich weitergeben oder <strong>QR-Code</strong> zeigen → Athlet direkt einloggen</span></li>
              </ul>
            </div>

            <div className="ap-wf-card">
              <div className="ap-wf-role">Für Athleten — via PIN</div>
              <div className="ap-wf-title">Mit PIN einloggen</div>
              <ul className="ap-wf-steps">
                <li className="ap-wf-step"><span>1️⃣</span><span><strong>my.tda-intl.org</strong> öffnen → „Ich bin Athlet" wählen</span></li>
                <li className="ap-wf-step"><span>2️⃣</span><span>Turnier aus der Liste auswählen (heutiges ist oben)</span></li>
                <li className="ap-wf-step"><span>3️⃣</span><span><strong>6-stelligen PIN</strong> eingeben (vom Trainer erhalten)</span></li>
                <li className="ap-wf-step"><span>4️⃣</span><span>Eigene Kämpfe sehen: Matte, Gegner, Ergebnis — nächster Kampf hervorgehoben</span></li>
              </ul>
            </div>

            <div className="ap-wf-card">
              <div className="ap-wf-role">Für Athleten — via QR</div>
              <div className="ap-wf-title">QR-Code scannen</div>
              <ul className="ap-wf-steps">
                <li className="ap-wf-step"><span>📲</span><span>Trainer öffnet Mein TDA → tippt „QR" neben dem Athleten</span></li>
                <li className="ap-wf-step"><span>🔳</span><span>Athlet scannt den QR-Code mit der Kamera-App (kein extra Scanner nötig)</span></li>
                <li className="ap-wf-step"><span>✅</span><span>Sofort eingeloggt — direkt zu den eigenen Kämpfen, kein PIN eintippen</span></li>
                <li className="ap-wf-step"><span>💡</span><span>QR kann als Bild gespeichert und per WhatsApp/Messenger geteilt werden</span></li>
              </ul>
            </div>

          </div>
        </div>

        <hr className="ap-divider" />

        {/* INSTALL */}
        <div className="ap-section">
          <div className="ap-section-title">Als App installieren</div>
          <div className="ap-section-sub">
            Kein App Store nötig — einfach auf dem Homescreen speichern und wie eine native App nutzen.
          </div>

          <div className="ap-install-grid">

            <div className="ap-install-card">
              <div className="ap-install-top">
                <div className="ap-install-os-icon"></div>
                <div>
                  <div className="ap-install-os-name">iPhone & iPad (iOS)</div>
                  <div className="ap-install-hint">Nur mit Safari — nicht mit Chrome oder Firefox</div>
                </div>
              </div>
              <ol className="ap-install-steps">
                <li className="ap-step">
                  <div className="ap-step-num">1</div>
                  <div className="ap-step-text"><strong>Safari</strong> öffnen (wichtig: nicht Chrome oder Firefox!)</div>
                </li>
                <li className="ap-step">
                  <div className="ap-step-num">2</div>
                  <div className="ap-step-text"><em>live.tda-intl.org</em> oder <em>my.tda-intl.org</em> aufrufen</div>
                </li>
                <li className="ap-step">
                  <div className="ap-step-num">3</div>
                  <div className="ap-step-text">Unten mittig das <strong>Teilen-Symbol</strong> antippen — Quadrat mit Pfeil nach oben (↑)</div>
                </li>
                <li className="ap-step">
                  <div className="ap-step-num">4</div>
                  <div className="ap-step-text">Nach unten scrollen → <strong>„Zum Home-Bildschirm"</strong> antippen</div>
                </li>
                <li className="ap-step">
                  <div className="ap-step-num">5</div>
                  <div className="ap-step-text">Namen bestätigen → oben rechts <strong>„Hinzufügen"</strong> antippen</div>
                </li>
                <li className="ap-step">
                  <div className="ap-step-num">6</div>
                  <div className="ap-step-text">TDA-Icon erscheint auf dem Homescreen — ab jetzt wie eine echte App öffnen</div>
                </li>
              </ol>
              <div className="ap-install-tip">
                💡 Schritt für beide Apps wiederholen — TDA Live und Mein TDA können beide auf dem Homescreen sein.
              </div>
            </div>

            <div className="ap-install-card">
              <div className="ap-install-top">
                <div className="ap-install-os-icon">🤖</div>
                <div>
                  <div className="ap-install-os-name">Android</div>
                  <div className="ap-install-hint">Empfohlen mit Google Chrome</div>
                </div>
              </div>
              <ol className="ap-install-steps">
                <li className="ap-step">
                  <div className="ap-step-num">1</div>
                  <div className="ap-step-text"><strong>Chrome</strong> öffnen und <em>live.tda-intl.org</em> oder <em>my.tda-intl.org</em> aufrufen</div>
                </li>
                <li className="ap-step">
                  <div className="ap-step-num">2</div>
                  <div className="ap-step-text"><strong>Variante A:</strong> Banner <strong>„App installieren"</strong> erscheint automatisch → antippen und bestätigen</div>
                </li>
                <li className="ap-step">
                  <div className="ap-step-num">3</div>
                  <div className="ap-step-text"><strong>Variante B:</strong> Drei-Punkte-Menü (⋮) oben rechts → <strong>„App installieren"</strong> oder <strong>„Zum Startbildschirm"</strong> wählen</div>
                </li>
                <li className="ap-step">
                  <div className="ap-step-num">4</div>
                  <div className="ap-step-text"><strong>„Hinzufügen"</strong> bestätigen — Icon erscheint auf dem Homescreen</div>
                </li>
              </ol>
              <div className="ap-install-tip">
                💡 Samsung-Browser und Firefox für Android unterstützen ebenfalls die Installation über das Menü.
              </div>
            </div>

            <div className="ap-install-card">
              <div className="ap-install-top">
                <div className="ap-install-os-icon">💻</div>
                <div>
                  <div className="ap-install-os-name">Desktop (Windows & Mac)</div>
                  <div className="ap-install-hint">Mit Chrome oder Edge</div>
                </div>
              </div>
              <ol className="ap-install-steps">
                <li className="ap-step">
                  <div className="ap-step-num">1</div>
                  <div className="ap-step-text"><strong>Chrome</strong> oder <strong>Edge</strong> öffnen und die gewünschte App aufrufen</div>
                </li>
                <li className="ap-step">
                  <div className="ap-step-num">2</div>
                  <div className="ap-step-text">In der Adresszeile rechts: kleines <strong>Computer-Icon mit Pfeil</strong> (↓) anklicken</div>
                </li>
                <li className="ap-step">
                  <div className="ap-step-num">3</div>
                  <div className="ap-step-text"><strong>„Installieren"</strong> bestätigen — App öffnet sich in eigenem Fenster ohne Browser-Leiste</div>
                </li>
                <li className="ap-step">
                  <div className="ap-step-num">4</div>
                  <div className="ap-step-text">Ab jetzt im Startmenü (Windows) oder Dock (Mac) verfügbar</div>
                </li>
              </ol>
              <div className="ap-install-tip">
                💡 Ideal für die Kampfrichtertafel oder einen dedizierten Turnier-Computer.
              </div>
            </div>

          </div>
        </div>

        {/* FAQ */}
        <div className="ap-section">
          <div className="ap-faq">
            <div className="ap-faq-title">Häufige Fragen</div>
            <div className="ap-faq-items">
              {FAQS.map((faq, i) => (
                <div key={i} className="ap-faq-item">
                  <div className="ap-faq-q">{faq.q}</div>
                  <div className="ap-faq-a">{faq.a}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
